<div [class]="accordionClass">
  @for (panel of panels; track panel) {
    <div
      class="accordion-item"
      [class.disabled]="panel.disabled">
      <!-- Header -->
      <h2 class="accordion-header" [id]="'heading-' + panel.id">
        <button
          type="button"
          class="accordion-button"
          [class.collapsed]="!isExpanded(panel.id)"
          [class.disabled]="panel.disabled"
          [attr.aria-expanded]="isExpanded(panel.id)"
          [attr.aria-controls]="'collapse-' + panel.id"
          [disabled]="panel.disabled"
          (click)="toggle(panel.id)">
          @if (panel.icon) {
            <lucide-icon [name]="panel.icon" class="icon-sm me-2"></lucide-icon>
          }
          <span class="accordion-title">{{ panel.title }}</span>
          @if (panel.subtitle) {
            <small class="text-muted ms-2">{{ panel.subtitle }}</small>
          }
        </button>
      </h2>
      <!-- Content -->
      <div
        [id]="'collapse-' + panel.id"
        class="accordion-collapse"
        [class.show]="isExpanded(panel.id)"
        [class.collapse-animation]="animation"
        [attr.aria-labelledby]="'heading-' + panel.id">
        <div class="accordion-body">
          @if (isExpanded(panel.id)) {
            <ng-container *ngTemplateOutlet="panel.contentTemplate"></ng-container>
          }
        </div>
      </div>
    </div>
  }
</div>
